import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.ServiciosAdicionalesGuiaModel;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
}

/**
* Componente para editar un Entity
*/
export class ServiciosAdicionalesComp extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Check = getField(kea.Checkbox);
        const TipoAcuse = getField(selectores.TipoAcuse);
        return (
            <kea.Panel iconClass={fa("plus")} title="Servicios adicionales" >
                {kea.autogrid(6, [
                    <Check field="EntregaDomicilio" label="Entrega a domicilio" />,
                    <Check field="RecoleccionDomicilio" label="RecoleccionDomicilio" />,
                    <TipoAcuse field="TipoAcuse" label="Tipo de acuse" />,
                    <Check field="FXC" label="Flete por cobrar" />
                ])}
            </kea.Panel>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/servadic.tsx